if(typeof BSS_B2B != 'undefined' && window.location.pathname === '/pages/test'){
  setTimeout(() => {
    const elms = document.querySelectorAll("#RegisterForm .field");
    if(elms.length){
      elms.forEach(item => {
        const label = item.querySelector("label");
        const input = item.querySelector("input");
        if(input && label){
          input.addEventListener("focus", ()=>{
            input.style = 'padding: 2.2rem 1.5rem 0.8rem 2rem;margin: var(--inputs-border-width);';
            label.style = 'font-size: 1rem;top: calc(var(--inputs-border-width) + 0.5rem);left: calc(var(--inputs-border-width) + 2rem);letter-spacing: .04rem;'
          })
           input.addEventListener("blur", ()=>{
            if(input.value.length === 0){
              input.style = 'padding: 1.5rem;margin:1px';
            label.style = 'font-size: 1.2rem;left: calc(var(--inputs-border-width) + 2rem);top: calc(1rem + var(--inputs-border-width));letter-spacing: .1rem;'
            }
          })
        }
      })
    }
  }, 300)
}